var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.23783203 1.05767578 -0.23783203 1.05767578 -0.48046875 2.13671875 C-1.84995008 9.68431137 -1.98907798 16.68487003 2.02734375 23.37890625 C3 25 3 25 4 28 C5.69769234 29.10168984 5.69769234 29.10168984 8 30 C8.94875 30.53625 9.8975 31.0725 10.875 31.625 C16.50923244 34.08920276 22.99160308 33.22500238 29 33 C27.70281867 36.86493514 26.28771467 39.04965004 23.1875 41.6875 C22.52105469 42.26886719 21.85460938 42.85023437 21.16796875 43.44921875 C14.7022238 48.07426514 7.6631914 47.6776972 0 47 C-6.65959333 45.31914417 -11.18547447 40.53621678 -15 35 C-18.23701739 28.56912546 -18.12389015 20.45288124 -16.3828125 13.5546875 C-13.64768645 7.38250039 -7.08493331 0 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(23,7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.3bc80cf1e1fbb0d637fccf960715ba9b.svg";
export { ForwardRef as ReactComponent };